import React from "react"
import { Link } from "react-router-dom"

export default function HomeHero() {
  return (
    <>
      <section className="hero">
        <div className="overlay relative flex flex-col items-center justify-center">
          <article className="md:w-8/12 md:mx-auto">
            <h1 className="text-white text-center">
              SJ Fast Own Motors and Accessories
            </h1>
            <p className="text-slate-200 text-center my-5 md:w-2/3 md:mx-auto">
              Get car accessories at affordable prices. We have lumbar supports,
              furry steering wheels, and more, in our collection. Start browsing
              below!
            </p>

            <button className="block mx-auto">
              <Link to="/accessories" className="btn-white">
                Browse Accessories
              </Link>
            </button>
          </article>
        </div>
      </section>
    </>
  )
}
